import React from "react"
import { useEffect, useState } from "react"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"
import { Label } from "@progress/kendo-react-labels"

import { Form, Field, FormElement } from "@progress/kendo-react-form"
import { Input, RadioGroup } from "@progress/kendo-react-inputs"
import { Button } from "@progress/kendo-react-buttons"
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { sendRegistrationLink } from "../../../Shared/Services/ApiService"

export default function SendRequest(props) {
  const { setAppBarTitle, backgroundProcessor, notificationCreate, appMode } = props
  const [formState, setFormState] = useState({})
  const [modal, setModal] = useState(false)
  const [submission, setSubmission] = useState({
    system: null,
    name: null,
    email: null,
  })

  useEffect(() => {
    setAppBarTitle("Send Registration Request")
  }, [])

  const systems = [
    { label: "Holba", value: "HOLBA" },
    { label: "NWEC", value: "NWEC" },
  ]
  const inputHandler = (e) => {
    let newValue = e.value
    let key = e.nativeEvent.srcElement.id

    submission[key] = newValue

    setSubmission(submission)
  }

  const submitHandler = async (e) => {
    if(submission.system === null){

      const sub = submission
      sub.system = appMode
      setSubmission(sub)
    }
    setModal(true)
  }

  const switchHandler = async (e) => {
    let sub = submission
    sub.system = e.value
    setSubmission(sub)
  }

  const confirmHandler = async (e) => {
    backgroundProcessor?.add()

    try {
      const submit = await sendRegistrationLink(submission)
      console.log(submit)

      notificationCreate({
        severity: "success",
        message: "Request Sent Succesfully",
      })
    } catch (error) {
      console.log("ERROR - " + error)
      notificationCreate({
        severity: "error",
        message: "Request Submission Error - Please Try Again",
      })
    }
    setModal(false)

    backgroundProcessor?.remove()
  }
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ paddingBottom: "1rem", backgroundColor: "lightgrey" }}
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
      >
        <Grid item>
          <h1>User Registration Request</h1>
        </Grid>
      </Grid>

      <Grid container item direction="column" style={{ maxWidth: "95vw" }}>
        <Paper elevation={3} className="home-container">
          <Grid container item direction="column">
            <Grid
              container
              item
              direction="column"
              alignItems="flex-start"
              style={{ paddingBottom: "1rem", paddingLeft: "1rem" }}
            >
              <Grid item>
                <h5>
                  Please confirm the email you would like to be sent the registration
                  request form
                </h5>
                <h5>
                  That email will then receive a link to the registration form where
                  they can fill in all their details, to then be approved or denied
                  access to the BIDS app
                </h5>
              </Grid>
              <Form
                initialValues={formState}
                onSubmit={submitHandler}
                render={(formRenderProps) => (
                  <FormElement>
                    <Grid container direction="column">
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="name"
                          name="name"
                          label="Name"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "Name is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                          style={{ width: "33vw" }}
                        />
                        {appMode === "Veolia" && (
                          <>
                            <Label
                              editorId="systemType"
                              style={{ paddingTop: "1rem" }}
                            >
                              System
                            </Label>
                            <Field
                              id="system"
                              name="system"
                              component={RadioGroup}
                              data={systems}
                              onChange={(e) => {
                                switchHandler(e)
                              }}
                            />
                          </>
                        )}
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="email"
                          name="email"
                          label="Email"
                          component={Input}
                          validator={(value) => {
                            return new RegExp(/\S+@\S+\.\S+/).test(value)
                              ? ""
                              : "Email is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                          style={{ width: "33vw" }}
                        />
                      </Grid>
                    </Grid>
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignContent: "center",
                      }}
                      className={"k-form-buttons k-buttons-end"}
                    >
                      <div>
                        <Button
                          themeColor="primary"
                          style={{ color: "white", backgroundColor: "#7ABCCE" }}
                          type={"submit"}
                          disabled={!formRenderProps.allowSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </FormElement>
                )}
              />
            </Grid>
          </Grid>
          {modal && (
            <Dialog
              title={"Registration Request"}
              onClose={(e) => setModal(false)}
              height="49vh"
              width="35vw"
              style={{ border: "1px solid #E95F47" }}
            >
              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ marginTop: "0.3rem" }}
                spacing={2}
              >
                <Grid item>
                  <p>
                    Please check all values before confirming your submission, or
                    click cancel to make any changes
                  </p>
                  <p>
                    The user will then be sent an email link, allowing them to
                    request their registration
                  </p>
                </Grid>
                <Grid item>
                  <strong>Name:</strong> {submission.name}
                </Grid>

                <Grid item>
                  <strong>Email:</strong> {submission.email}
                </Grid>
                <Grid item>
                  <strong>System:</strong> {submission.system}
                </Grid>
              </Grid>
              <DialogActionsBar>
                <>
                  <Button
                    style={{ backgroundColor: "#E95F47", color: "white" }}
                    onClick={(e) => confirmHandler(e)}
                  >
                    Confirm
                  </Button>
                  <Button
                    style={{ backgroundColor: "#E95F47", color: "white" }}
                    onClick={(e) => setModal(false)}
                  >
                    Cancel
                  </Button>
                </>
              </DialogActionsBar>
            </Dialog>
          )}
        </Paper>
      </Grid>
    </Grid>
  )
}
